// extracted by mini-css-extract-plugin
module.exports = {"container":"_1aJ8uwiwV0feHBlgMnCYCI","label":"_2Jg_Op7Gzc2cFeL7eRhrKN","icon":"_15r815JGcfXg68O1ufHC8Z"};